import { Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { KPI } from '../api';
import { idMapToArray, ScopeService } from './scope.service';

interface SubCategoryTree extends KPI.SubCategory {
  children: KPI.AssetType[];
}

interface CategoryTree extends KPI.Category {
  children: SubCategoryTree[];
}

export interface SuperCategoryTree extends KPI.SuperCategory {
  children: CategoryTree[];
}

@Injectable()
export class AssetTypesTreeService {

  private _assetTypesTrees$: Observable<SuperCategoryTree[]>;

  constructor(
    private scope: ScopeService,
  ) { }

  public get assetTypesTrees$(): Observable<SuperCategoryTree[]> {
    if (!this._assetTypesTrees$) {
      this._assetTypesTrees$ = combineLatest(
        this.scope.superCategories$.pipe(idMapToArray()),
        this.scope.categories$.pipe(idMapToArray()),
        this.scope.subCategories$.pipe(idMapToArray()),
        this.scope.assetTypes$.pipe(idMapToArray()),
      ).pipe(
        map(([superCategories, categories, subCategories, assetTypes]) => {
          const trees = superCategories.map((superCategory) => {
            const categoryTrees = categories
              .filter((category) => category.parent === superCategory.id)
              .map((category) => {
                const subCategoryTrees = subCategories
                  .filter((subCategory) => subCategory.parent === category.id)
                  .map((subCategory) => {
                    const children = assetTypes.filter((assetType) => assetType.parent === subCategory.id);

                    return {
                      ...subCategory,
                      children,
                    };
                  })
                ;

                return {
                  ...category,
                  children: subCategoryTrees,
                };
              })
            ;

            return {
              ...superCategory,
              children: categoryTrees,
            };
          });

          return trees;
        }),
        shareReplay(1),
      );
    }

    return this._assetTypesTrees$;
  }

}
